module.exports = __webpack_public_path__ + "img/nap_thumb_2.33666223.jpg";